const REQUEST_REPORT_DATA = 'REQUEST_REPORT_DATA'
const RESPONSE_REPORT_DATA = 'RESPONSE_REPORT_DATA'
const REQUEST_REPORT_DATA_FAILURE = 'REQUEST_REPORT_DATA_FAILURE'
const SET_REPORT_PARAMS_READY = 'SET_REPORT_PARAMS_READY'
const SET_REPORT_PARAMS_NOT_READY = 'SET_REPORT_PARAMS_NOT_READY'
const SET_REPORT_DATA_NOT_REQUESTED = 'SET_REPORT_DATA_NOT_REQUESTED'
const SET_REPORT_DATA_REQUEST = 'SET_REPORT_DATA_REQUEST'
const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA'

const requestReportDataAction = (startDate, endDate) => {
  return {
    type: REQUEST_REPORT_DATA,
    payload: { startDate, endDate }
  }
}

const requestReportData = (startDate, endDate) => {
  return (dispatch) => {
    dispatch(requestReportDataAction(startDate, endDate))
  }
}

const responseReportDataAction = () => {
  return {
    type: RESPONSE_REPORT_DATA
  }
}

const setReportDataReady = () => {
  return (dispatch) => {
    dispatch(responseReportDataAction())
  }
}

const requestReportDataFailureAction = () => {
  return {
    type: REQUEST_REPORT_DATA_FAILURE
  }
}

const setReportDataFailure = () => {
  return (dispatch) => {
    dispatch(requestReportDataFailureAction())
  }
}

const setReportParamsReadyAction = () => {
  return {
    type: SET_REPORT_PARAMS_READY
  }
}

const setReportParamsReady = () => {
  return (dispatch) => {
    dispatch(setReportParamsReadyAction())
  }
}

const setReportParamsNotReadyAction = () => {
  return {
    type: SET_REPORT_PARAMS_NOT_READY
  }
}

const setReportParamsNotReady = () => {
  return (dispatch) => {
    dispatch(setReportParamsNotReadyAction())
  }
}

const setReportDataNotRequestedAction = () => {
  return {
    type: SET_REPORT_DATA_NOT_REQUESTED
  }
}

const setReportDataNotRequested = () => {
  return (dispatch) => {
    dispatch(setReportDataNotRequestedAction())
  }
}

const setReportDataRequestAction = () => {
  return {
    type: SET_REPORT_DATA_REQUEST
  }
}

const setReportDataRequest = () => {
  return (dispatch) => {
    dispatch(setReportDataRequestAction())
  }
}

const clearReportDataAction = () => {
  return {
    type: CLEAR_REPORT_DATA
  }
}

export {
  REQUEST_REPORT_DATA,
  RESPONSE_REPORT_DATA,
  REQUEST_REPORT_DATA_FAILURE,
  SET_REPORT_PARAMS_READY,
  SET_REPORT_PARAMS_NOT_READY,
  SET_REPORT_DATA_NOT_REQUESTED,
  SET_REPORT_DATA_REQUEST,
  CLEAR_REPORT_DATA,
  requestReportDataAction,
  requestReportData,
  responseReportDataAction,
  setReportDataReady,
  requestReportDataFailureAction,
  setReportDataFailure,
  setReportParamsReadyAction,
  setReportParamsReady,
  setReportParamsNotReadyAction,
  setReportParamsNotReady,
  setReportDataNotRequestedAction,
  setReportDataNotRequested,
  setReportDataRequestAction,
  setReportDataRequest,
  clearReportDataAction
}